import { filter } from 'lodash';
import {
  CAMPAIGN_SAVE_SUCCESS,
  CAMPAIGN_SAVE_FAILURE,
  RELEVANT_CAMPAIGNS_LOAD_SUCCESS,
  RELEVANT_CAMPAIGNS_LOAD_FAILURE,
  CAMPAIGN_RETIRE_SUCCESS,
  CAMPAIGN_RETIRE_FAILURE
} from '../constants';
import { campaignStatuses, dealStatuses } from '../../constants';

export const saveCampaign = (campaignData, ownProps) => {
  return (dispatch, getState, { getFirestore, getFirebase }) => {
    const firestore = getFirestore();
    const firebase = getFirebase();
    const user = firebase.auth().currentUser;

    firestore
      .add(
        { collection: 'campaigns' },
        {
          ...campaignData,
          creator: user.uid,
          createdAt: firestore.FieldValue.serverTimestamp(),
          status: campaignStatuses.PENDING,
          payoutMin: parseFloat(campaignData.payoutMin),
          payoutMax: parseFloat(campaignData.payoutMax)
        }
      )
      .then(() => {
        dispatch({ type: CAMPAIGN_SAVE_SUCCESS, payload: { campaignData } });
        ownProps.history.push('/dashboard');
      })
      .catch(err => {
        dispatch({ type: CAMPAIGN_SAVE_FAILURE, err });
      });
  };
};

export const retireCampaign = (campaignId, ownProps) => {
  return (dispatch, getState, { getFirestore }) => {
    const deals = getState().firestore.ordered.deals;
    const firestore = getFirestore();

    // check if all deals on the campaign are COMPLETE
    // if not then do not allow deal retiring
    // NOTE: I'm letting them retire despite having open deals for now - i don't think its a problem,
    // it just means no one else is allowed to apply to it

    // const incompleteDeals = filter(deals, deal => deal.campaignId === campaignId
    //   && (deal.status !== dealStatuses.COMPLETE && deal.status !== dealStatuses.MATCH_REJECTED
    //     && deal.status !== dealSnapshot.UNMATCHED && deal.status !== dealSnapshot.DISPUTE_OPENED)
    //   );
    // if(incompleteDeals.length) {
    //   return dispatch({
    //     type: CAMPAIGN_RETIRE_FAILURE,
    //     payload: { message: `Can't retire - you have open deals on this campaign` }
    //   });
    // }
    firestore
      .collection('campaigns')
      .doc(campaignId)
      .get()
      .then(campSnapshot => {
        if (!campSnapshot) {
          return dispatch({
            type: CAMPAIGN_RETIRE_FAILURE,
            payload: { message: 'campaign doesnt exist' }
          });
        }

        campSnapshot.ref
          .update({
            status: campaignStatuses.RETIRED
          })
          .then(response => {
            dispatch({
              type: CAMPAIGN_RETIRE_SUCCESS,
              payload: {}
            });
            ownProps.history.push('/campaigns');
          });
      })
      .catch(err => {
        dispatch({
          type: CAMPAIGN_RETIRE_FAILURE,
          payload: { err }
        });
      });
  };
};

export const loadRelevantCampaigns = influencerUid => {
  return (dispatch, getState, { getFirestore }) => {
    const firestore = getFirestore();
    firestore
      .collection('campaigns')
      .orderBy('createdAt', 'desc')
      .where('status', '==', 'ACTIVE')
      .where('isPrivate', '==', false)
      .limit(5)
      .get()
      .then(campaignSnapshots => {
        if (campaignSnapshots && campaignSnapshots.docs.length) {
          const userRequests = campaignSnapshots.docs.map(campaignDoc => {
            return new Promise(resolve => {
              const campaign = campaignDoc.data();
              firestore
                .collection('users')
                .doc(campaign.creator)
                .get()
                .then(companyDoc => {
                  const company = { ...companyDoc.data(), id: companyDoc.id };

                  firestore
                    .collection('deals')
                    .where('influencerId', '==', influencerUid)
                    .where('campaignId', '==', campaignDoc.id)
                    .where('companyId', '==', companyDoc.id)
                    .get()
                    .then(dealSnapshot => {
                      if (dealSnapshot && dealSnapshot.docs.length) {
                        resolve({
                          ...campaign,
                          id: campaignDoc.id,
                          company,
                          matchRequested: true
                        });
                      } else {
                        resolve({
                          ...campaign,
                          id: campaignDoc.id,
                          company,
                          matchRequested: false
                        });
                      }
                    });
                });
            });
          });

          Promise.all(userRequests).then(campaigns => {
            dispatch({
              type: RELEVANT_CAMPAIGNS_LOAD_SUCCESS,
              payload: { campaigns }
            });
          });
        } else {
          dispatch({
            type: RELEVANT_CAMPAIGNS_LOAD_SUCCESS,
            payload: { campaigns: [] }
          });
        }
      })
      .catch(err => {
        dispatch({ type: RELEVANT_CAMPAIGNS_LOAD_FAILURE, err });
      });
  };
};



// WEBPACK FOOTER //
// ./src/store/actions/campaignActions.js